import { tv, type VariantProps } from "tailwind-variants";

export const resourceItemVariant = tv({
  slots: {
    base: ["w-full"],
    wrapper: ["group", "relative", "flex", "gap-5", "w-full"],
    cardMediaWrapper: ["relative", "overflow-hidden", "mobile:shrink-0"],
    mediaWrapper: ["w-full", "h-full"],
    media: [
      "w-full",
      "h-full",
      "object-cover",
      "transition-all",
      "duration-300",
      "ease-in-out",
      "group-hover:scale-110",
    ],
    content: ["flex", "flex-col", "items-start", "justify-center", "gap-2", "w-full"],
    title: ["text-text-neutral-default"],
    description: ["text-text-neutral-soft"],
    iconWrapper: ["hidden", "transition-all", "duration-300", "ease-in-out"],
    icon: [""],
    customIconWrapper: [
      "absolute",
      "bottom-4",
      "right-4",
      "z-10",
      "hidden",
      "items-center",
      "justify-center",
      "w-10",
      "h-10",
      "bg-static-black",
      "border",
      "border-border-neutral-inverse-softer",
      "rounded-full",
      "transition-all",
      "duration-300",
      "ease-in-out",
      "lg:flex",
    ],
    legend: [],
    loading: ["flex", "items-center", "justify-center", "text-text-static-white-soft"],
    loadingLabel: ["text-2 text-text-static-white-soft"],
  },
  variants: {
    appearance: {
      grid: {
        wrapper: [
          "p-2",
          "border",
          "border-neutral-dark-alpha/10",
          "rounded-2xl",
          "desktop:flex-col",
          "desktop:p-0",
          "desktop:rounded-0",
          "desktop:border-0",
        ],
        content: ["desktop:justify-between"],
        cardMediaWrapper: [
          "w-4/8",
          "h-full",
          "rounded-2xl",
          "border",
          "border-border-neutral-default",
          "desktop:w-full",
          "mobile:aspect-[191/155]",
        ],
        iconWrapper: [
          "absolute",
          "bottom-2",
          "right-2",
          "z-10",
          "flex",
          "items-center",
          "justify-center",
          "w-6",
          "h-6",
          "bg-static-black",
          "border",
          "border-border-neutral-inverse-softer",
          "rounded-full",
          "desktop:hidden",
        ],
        icon: ["flex", "w-4", "h-4", "text-white"],
        titleSize: ["titleExtraLarge"],
        descriptionSize: ["bodySmall"],
      },
      inline: {
        wrapper: ["p-2", "border", "border-neutral-dark-alpha/10", "rounded-2xl"],
        content: ["gap-2"],
        cardMediaWrapper: [
          "w-4/8",
          "h-full",
          "max-w-55",
          "rounded-lg",
          "desktop:w-5/8",
          "mobile:aspect-[191/155]",
        ],
        iconWrapper: [
          "absolute",
          "bottom-2",
          "right-2",
          "z-10",
          "flex",
          "items-center",
          "justify-center",
          "w-6",
          "h-6",
          "bg-static-black",
          "rounded-full",
        ],
        icon: ["flex", "w-4", "h-4", "text-white"],
        customIconWrapper: ["lg:hidden"],
      },
    },
    aspectRatio: {
      "aspect_1/1": {
        cardMediaWrapper: ["aspect-1/1"],
      },
      "aspect_16/13": {
        cardMediaWrapper: ["aspect-16/13"],
      },
    },
    isLoading: {
      true: {
        iconWrapper: ["w-auto p-2 gap-1"],
        customIconWrapper: ["w-auto px-2 gap-1"],
      },
      false: {},
    },
  },
  defaultVariants: {},
});

export type ResourceItemVariantProps = VariantProps<typeof resourceItemVariant>;
export type ResourceItemReturnVariantProps = ReturnType<typeof resourceItemVariant>;
